export default () => {
    const KEY = 'NOTICE_CLOSED';
    const notice = document.querySelector('[data-notice]');
    const close = document.querySelector('[data-notice-close]');

    if (!notice) {
        return;
    }

    const date = localStorage.getItem(KEY);
    const now = new Date();
    let dateClosed = null;
    let diff = 0;

    if (date) {
        dateClosed = new Date(date);
        diff = Math.ceil(Math.abs(now - dateClosed) / (1000 * 60 * 60 * 24));
    }

    if (diff == 0 || diff > 2) {
        notice.classList.add('active');
    }

    close.addEventListener('click', () => {
        notice.classList.remove('active');
        localStorage.setItem(KEY, new Date());
    });
}
